<script setup lang="ts">
import type { SelectContentProps } from "./select.types";
import { useSelectContent } from "./useSelect.Content";
import { DEFAULT_POSITIONING } from "composables/usePosition";

defineOptions({ name: "SelectContent" });

const props = withDefaults(defineProps<SelectContentProps>(), {
  placement: DEFAULT_POSITIONING.placement,
  offset: DEFAULT_POSITIONING.offset,
  maxHeight: "300px",
});

const { triggerId, listboxStyle, positioning, select, handleFloatingClose, handleFloatingOpen } = useSelectContent({
  props,
});
</script>

<template>
  <e-floating
    class="e-select-content"
    :trigger="`#${triggerId}`"
    :placement="positioning.placement"
    :offset="positioning.offset"
    :boundary-margin="positioning.boundaryMargin"
    :collision-strategy="positioning.collisionStrategy"
    :open="select.isOpen.value"
    close-on-click-outside
    rendering-strategy="absolute"
    trigger-mode="manual"
    eager
    @close="handleFloatingClose"
    @open="handleFloatingOpen"
  >
    <e-listbox
      :class="$attrs.class"
      :style="listboxStyle"
      :color="select.selectProps.value?.color"
      :variant="select.selectProps.value?.variant"
      size="xs"
      :multiple="select.selectProps.value?.multiple"
      :disabled="select.selectProps.value?.disabled"
      :model-value="select.modelValue.value"
      :highlighted-value="select.highlightedValue.value"
      selection-behavior="replace"
      prevent-page-scroll
    >
      <slot />
    </e-listbox>
  </e-floating>
</template>

<style>
:host {
  display: contents;
}
</style>
